import Head from "next/head";
import { Thing } from "schema-dts";

interface StructuredDataProps {
  schemas: Thing[];
}

const StructuredData = ({ schemas }: StructuredDataProps) => {
  return (
    <Head>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </Head>
  );
};

export default StructuredData;
